<svg class="icon">
	<use [attr.xlink:href]="src" />
</svg>
